import Component from "../component.abstract"

interface SimpleProgressProps {
    backColor?: string;
    frontColor?: string;
    velocity?: number;
}

/**
 * Simple Progress component
 */
export default class SimpleProgress extends Component {
    private progressInterval: any;

    constructor(
        private props:SimpleProgressProps,
        element:HTMLElement
    ) {
        super(props, element)
    }

    mounted ():void {}

    start () {
        let current_progress = 0,
            step = this.props.velocity || 0.2;

        // Add some basics styles
        this.element.classList.add('simpleProgress');

        // If the element isn't positionned we add a minimum relative positionnement for safe positionning our fake progress bar element
        const computedStyle = getComputedStyle(this.element);
        this.element.style.position = this.element.style.position === '' && computedStyle.position === 'static' ? 'relative' : this.element.style.position ?? computedStyle.position;
        this.element.style.zIndex = this.element.style.zIndex === '' && computedStyle.zIndex === 'auto' ? '0' : this.element.style.zIndex ?? computedStyle.zIndex;

        // This will apply the bgcolor to the element
        if(this.props.backColor !== undefined) this.element.style.backgroundColor = this.props.backColor;

        // Create and stylish our fake progress bar element
        const elFakeBar = document.createElement('div');
        elFakeBar.classList.add('simpleProgress__bar');

        if(this.props.frontColor !== undefined) elFakeBar.style.backgroundColor = this.props.frontColor;
        this.element.appendChild(elFakeBar);

        this.progressInterval = setInterval(() => {
            current_progress += step;
            const progress = Math.round(Math.atan(current_progress) / (Math.PI / 2) * 100 * 1000) / 1000
            elFakeBar.style.width = progress + '%';

            if (progress >= 100){
                clearInterval(this.progressInterval);
            } else if(progress >= 90) {
                step = 0.1
            }
        }, 100);
    }

    stop () {
        clearInterval(this.progressInterval);
        (<HTMLElement> this.element.lastElementChild).style.width = '100%';
        (<HTMLElement> this.element.lastElementChild).style.opacity = '0';

        // This setTimeout serve CSS transition visibility purpose without it the element will disappear instantly
        setTimeout(() => {
            const lastChild = this.element.lastElementChild;
            if (lastChild) {
                this.element.removeChild(this.element.lastElementChild);
            }
            this.element.removeAttribute('style');
            // Remove basics styles
            this.element.classList.remove('simpleProgress');
        }, 250);

    }
}